<template>
  <div class="combined_sales_binding">

    <!--组合销售绑定头部-->
    <div class="combined_sales_binding_list_top">
      <div><input type="text" v-model.trim="combinedSalesNum" title="组合商家编码" placeholder="组合商家编码"></div>
      <div><input type="text" v-model.trim="idOrName" title="货品/品名" placeholder="货品/品名"></div>
      <div><input type="text" v-model.trim="SKUSalesNum" title="SKU商家编码" placeholder="SKU商家编码"></div>
      <button class="btn_normal w116 ml5" @click="queryData()">查询</button>
      <button class="btn_normal ml5 pl7 pr7" @click="ctrlBtn('add')">新增组合销售</button>
      <button class="btn_normal ml5 pl7 pr7" @click="getGroupGoodsImportExcelTemplet()">下载导入模板</button>
      <button class="btn_normal ml5 pl7 pr7" @click="ctrlBtn('import')">导入组合商家编码</button>
    </div>

    <!--这里是组合销售绑定信息-->
    <div class="combined_sales_binding_list_msg">
      <!--表格-->
      <table class="table tb_border">
        <thead>
        <tr>
          <th>组合商家编码</th>
          <th>货号</th>
          <th>品名</th>
          <th>SKU商家编码</th>
          <th>颜色</th>
          <th>尺码</th>
          <th>类型</th>
          <th>数量</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(item) in list">
          <tr v-for="(itemChild, indexChild) in item.GroupDetailList">
            <td v-if="indexChild < 1" :rowspan="item.GroupDetailList.length">{{item.GroupBusinessCode}}</td>
            <td>{{itemChild.GoodsId}}</td>
            <td>{{itemChild.GoodsName}}</td>
            <td>{{itemChild.BusinessCode}}</td>
            <td>{{itemChild.ColorAlias}}</td>
            <td>{{itemChild.Size}}</td>
            <td>{{itemChild.SType | sellorsend}}</td>
            <td>{{itemChild.Quantity}}</td>
            <td v-if="indexChild === 0" :rowspan="item.GroupDetailList.length">
              <a title="编辑" @click="ctrlBtn('modify', item)">编辑</a>
              <a title="删除" @click="ctrlBtn('del', item)">删除</a>
            </td>
          </tr>
        </template>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="9">暂时没有相关的内容</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <combined-sales-binding-embed-msg v-if="isShow" :title="dialogTitle" :combinedSalesMsg="combinedSalesMsg"
                                      :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></combined-sales-binding-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import CombinedSalesBindingEmbedMsg from './combined-sales-binding-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'combined-sales-binding',
    components: {CombinedSalesBindingEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        combinedSalesNum: '', // 组合商家编码
        idOrName: '', // 货品/品名
        SKUSalesNum: '', // SKU商家编码
        list: [], // 组合销售绑定列表
        combinedSalesMsg: '', // 组合编码信息
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 根据组合商家编码 + 货品/品名 + SKU商家编码 查询
      queryData() {
        this.currentPage = 1;
        this.loadAllGroupGoodsDetailPageData();
      },

      // 获取组合销售绑定分页数据
      loadAllGroupGoodsDetailPageData() {
        this.isLoading = true;
        this.list = [];
        // let newList = [];
        const params = {
          idOrName: this.idOrName,
          GroupBusinessCode: this.combinedSalesNum,
          BusinessCode: this.SKUSalesNum,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAllGroupGoodsDetailPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, combinedSalesMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.combinedSalesMsg = combinedSalesMsg;
        switch (type) {
          case 'add':
            this.dialogTitle = '新增组合编码';
            break;
          case 'modify':
            this.dialogTitle = '编辑组合编码（' + combinedSalesMsg.GroupBusinessCode + '）';
            break;
          case 'del':
            this.dialogTitle = '提示';
            break;
          case 'import':
            this.dialogTitle = '提示';
            break;
        }
      },

      // 获取组合编码导入模板
      getGroupGoodsImportExcelTemplet() {
        this.$axios.get(this.Global.getGroupGoodsImportExcelTemplet).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType === true) {
          this.loadAllGroupGoodsDetailPageData();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAllGroupGoodsDetailPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAllGroupGoodsDetailPageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.loadAllGroupGoodsDetailPageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.isShow = false;
        this.idOrName = '';
        this.combinedSalesNum = '';
        this.SKUSalesNum = '';
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadAllGroupGoodsDetailPageData();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .btn_normal {
    &.pl7 {
      padding-left: 7px;
    }
    &.pr7 {
      padding-right: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/combined-sales-binding.vue